import {CdkDrag, CdkDragDrop, CdkDropList, CdkDropListGroup} from '@angular/cdk/drag-drop';

import {ChangeDetectionStrategy, Component, inject, Input} from '@angular/core';
import {Router} from '@angular/router';
import {NbCheckboxModule, NbIconModule, NbTooltipModule} from '@nebular/theme';
import {Columns} from 'compob2b-table';
import {Widget} from '../../interfaces/Widget';
import {ListTable} from '../../services/list.table';
import {ListTableService} from '../../services/list.table.service';
import {MatMenu, MatMenuTrigger} from '@angular/material/menu'
import {TuiIcon} from '@taiga-ui/core'

@Component({
  selector: 'grid-gear',
  templateUrl: './grid-gear.component.html',
  styleUrl: './grid-gear.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NbCheckboxModule,
    CdkDrag,
    CdkDropListGroup,
    CdkDropList,
    NbTooltipModule,
    MatMenu,
    MatMenuTrigger,
    TuiIcon,
    NbIconModule
]
})
export class GridGearComponent {
  @Input() list: ListTable;

  protected router = inject(Router);

  get tableService(): ListTableService {
    return this.list.tableService;
  }

  get columns(): Columns[] {
    return this.list.columns;
  }

  setColumn(column: Columns, event: boolean): void {
    if (!column.readonly) {
      this.tableService.setColumn(column, event);
    }
  }

  isWidgetChecked(widget: Widget): boolean {
    return this.tableService.getWidgets()?.filter(item => (item.uri === widget.uri && item.type === widget.type)).length > 0;
  }

  setWidget(widget: Widget, event): void {
    const widgetsConfig: Widget[] = this.tableService.getWidgets();

    let newConfig: Widget[];
    if (event) {
      widget.fullUri = this.router.url;
      newConfig = widgetsConfig;
      newConfig.push(widget);
    } else {
      newConfig = widgetsConfig.filter(item => item.uri !== widget.uri || item.type !== widget.type);
    }
    this.tableService.writeWidgetConfig(newConfig);
  }

  drop($event: CdkDragDrop<any>) {
    const fromIndex = $event.previousContainer.data.index;
    const toIndex = $event.container.data.index;

    this.tableService.moveColumn(fromIndex, toIndex);
    this.tableService.saveConfig($event);
  }
}
